import { Stack, Typography } from '@mui/material'
import { useSmartTranslation } from '../../../generic/hooks/useSmartTranslation'
import CenteredText from '../common/CenteredText'
import BaseWidgetProvider from './BaseWidgetProvider'

const UnknonwWidget = () => {
  const { t_ } = useSmartTranslation()
  return (
    <CenteredText>
      <Stack>
        <Typography color='error' variant='h6'>{t_('Remove this widget')}</Typography>
        <Typography color='error' variant='h7'>{t_('Unknown widget type')}</Typography>
      </Stack>
    </CenteredText>
  )
}

class UnknonwWidgetProvider extends BaseWidgetProvider {
  getCode = () => 'UnknownWidget'

  getName = () => 'Unknwon widget'

  getStatus = () => 'error'

  createWidget = (props) => <UnknonwWidget {...props} />
}

export default UnknonwWidgetProvider
